export default __webpack_public_path__ + "static/run-0a123222c75c86fc0c92cdacc73ebdb4.png";